import Api from './api';

const LgpdService = {
    cadastro: async (params) => {
        const response = await Api.post('/lgpd/cadastrar', params)
        return response
    }
}

export default LgpdService;